import { render, staticRenderFns } from "./ContrattoPnrr.vue?vue&type=template&id=3522934b&"
import script from "./ContrattoPnrr.vue?vue&type=script&lang=js&"
export * from "./ContrattoPnrr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports